// src/components/CitationForm.js
import React, { useState } from 'react';
import { addComment } from '../firebase/comments';

const CitationForm = ({ user, onError }) => {
  const [author, setAuthor] = useState('');
  const [articleTitle, setArticleTitle] = useState('');
  const [publication, setPublication] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [url, setUrl] = useState('');
  const [citationText, setCitationText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!author.trim() || !articleTitle.trim() || !citationText.trim()) return;
    
    setIsSubmitting(true);
    setSuccessMessage('');
    
    try {
      const newCitation = {
        author,
        articleTitle,
        publication,
        publicationDate,
        url,
        citationText,
        type: 'citation',
        submittedBy: user.displayName,
        submitterId: user.uid,
        submitterPhoto: user.photoURL,
        course: 'exam-content',
        platform: 'cosknow'
      };
      
      await addComment(newCitation);
      
      // Reset form
      setAuthor('');
      setArticleTitle('');
      setPublication('');
      setPublicationDate('');
      setUrl('');
      setCitationText('');
      
      // Show success message
      setSuccessMessage('Citation added successfully!');
      
      // Clear success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
      
    } catch (err) {
      onError('Failed to submit citation. Please try again.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="form-container">
      <h3>Add an Article Citation</h3>
      
      {successMessage && (
        <div className="success-message">{successMessage}</div>
      )}
      
      <div className="form-group">
        <label htmlFor="article-author">Author:</label>
        <input
          id="article-author"
          type="text"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          placeholder="Article author"
          required
          disabled={isSubmitting}
        />
      </div>
      <div className="form-group">
        <label htmlFor="article-title">Article Title:</label>
        <input
          id="article-title"
          type="text"
          value={articleTitle}
          onChange={(e) => setArticleTitle(e.target.value)}
          placeholder="Title of the article"
          required
          disabled={isSubmitting}
        />
      </div>
      <div className="form-group">
        <label htmlFor="publication">Publication:</label>
        <input
          id="publication"
          type="text"
          value={publication}
          onChange={(e) => setPublication(e.target.value)}
          placeholder="Journal or website name"
          disabled={isSubmitting}
        />
      </div>
      <div className="form-group">
        <label htmlFor="publication-date">Publication Date:</label>
        <input
          id="publication-date"
          type="date"
          value={publicationDate}
          onChange={(e) => setPublicationDate(e.target.value)}
          disabled={isSubmitting}
        />
      </div>
      <div className="form-group">
        <label htmlFor="article-url">URL:</label>
        <input
          id="article-url"
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://example.com/article"
          disabled={isSubmitting}
        />
      </div>
      <div className="form-group">
        <label htmlFor="citation-text">Citation Text:</label>
        <textarea
          id="citation-text"
          value={citationText}
          onChange={(e) => setCitationText(e.target.value)}
          placeholder="Enter the text you are citing that relates to the exam content..."
          rows="4"
          required
          disabled={isSubmitting}
        />
      </div>
      <button 
        type="submit" 
        className="submit-button"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Adding...' : 'Add Citation'}
      </button>
    </form>
  );
};

export default CitationForm;